import _ from 'lodash';
import React from 'react';
import autobind from 'autobind-decorator';

@autobind
class ConfirmButton extends React.Component {
	constructor (props) {
		super(props);

		this.state = {
			showConfirmation: false
		};
	}

	render () {
		return (
			<div className="delete-button-container delete-button-container">
				{ this.renderConfirmation() }
				{  this.renderChildren() }
			</div>
		);
	}

	renderChildren () {
		const { children } = this.props;

		if (_.isEmpty(children)) {

			return this.renderDefaultButton();
		}

		return React.Children.map(children, (child) => {
			return React.cloneElement(child, {
				onClick: this.onClick
			});
		});
	}

	renderDefaultButton () {
		const { label = 'Delete' } = this.props;
		return (
			<button className="button alert" onClick={ this.onClick }>
				{ label }
			</button>
		);
	}

	renderConfirmation () {
		if (this.state.showConfirmation !== true) {

			return null;
		}

		const {
			confirmLabel = 'Confirm',
			cancelLabel = 'Cancel',
			warningText = 'Really delete item?',
			orientation = 'center'
		 } = this.props;

		return (
			<div className={ `delete-button-confirmation delete-button-confirmation ${ orientation } card padding-1` }>
				<div className="up-arrow bg"></div>
				<div className="up-arrow"></div>

				<p>{ warningText }</p>

				<div className="grid-x grid-padding-x align-middle">
					<div className="cell auto">
						<button className="button small alert margin-0 expanded" onClick={ this.onConfirmClick }>{ confirmLabel }</button>
					</div>
					<div className="cell auto">
						<button className="button small secondary margin-0 expanded" onClick={ this.onCancelClick }>{ cancelLabel }</button>
					</div>
				</div>
			</div>
		);
	}

	onClick (evt) {
		const { onClick = () => {} } = this.props;
		evt.stopPropagation();

		this.setState({
			showConfirmation: true
		});

		onClick(evt);
	}

	onConfirmClick (evt) {
		const { onConfirmClick = () => {} } = this.props;
		evt.stopPropagation();

		this.setState({
			showConfirmation: false
		});

		onConfirmClick(evt);
	}

	onCancelClick (evt) {
		const { onCancelClick = () => {} } = this.props;
		evt.stopPropagation();

		this.setState({
			showConfirmation: false
		});

		onCancelClick(evt);
	}
}

export default ConfirmButton;
